var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "snow-group" },
    _vm._l(_vm.snowflakes, function(flake, index) {
      return _c("img", {
        key: index,
        staticClass: "snow",
        style: {
          left: flake.left,
          width: flake.size,
          animationDuration: flake.duration,
          animationDelay: flake.delay,
          opacity: flake.opacity || "0.3"
        },
        attrs: { src: flake.img }
      })
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c28e58e2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c28e58e2","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/materials/SnowFlake.vue
// module id = 1556
// module chunks = 0